module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea.3f23b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product/flea.jpg
// module id = AivI
// module chunks = 0